"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContentBlockCard;
const react_1 = __importDefault(require("react"));
const ContentBlockCard_module_scss_1 = __importDefault(require("./ContentBlockCard.module.scss"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const buildImageUrl_1 = require("../../utils/buildImageUrl");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const LOGO_POSITION_CLASS = {
    "Top Left": ContentBlockCard_module_scss_1.default.logoTopLeft,
    "Bottom Left": ContentBlockCard_module_scss_1.default.logoBottomLeft,
    "Top Right": ContentBlockCard_module_scss_1.default.logoTopRight,
    "Bottom Right": ContentBlockCard_module_scss_1.default.logoBottomRight,
    Top: ContentBlockCard_module_scss_1.default.logoGroupTop,
    Bottom: ContentBlockCard_module_scss_1.default.logoGroupBottom,
    Left: ContentBlockCard_module_scss_1.default.logoGroupLeft,
    Right: ContentBlockCard_module_scss_1.default.logoGroupRight,
};
const LOGO_IMAGE_PARAMS = { fmt: "auto", wid: "120" };
const PREVIEWER_IMAGE_SIZE = {
    mobile: "343",
    tablet: "582",
    desktop: "902",
};
const PREVIEWER_LOGO_SIZE = {
    mobile: "75",
    tablet: "128",
    desktop: "198",
};
function LogoOverlay({ logoImage, logoAccessibilityText, logoPosition, logo2Image, logo2AccessibilityText, previewerSize, }) {
    const logoParams = previewerSize
        ? { fmt: "auto", wid: PREVIEWER_LOGO_SIZE[previewerSize] }
        : LOGO_IMAGE_PARAMS;
    const logo1Src = (0, buildImageUrl_1.buildImageUrl)(logoImage, logoParams);
    const logo2Src = logo2Image
        ? (0, buildImageUrl_1.buildImageUrl)(logo2Image, logoParams)
        : undefined;
    const logoClassName = previewerSize
        ? ContentBlockCard_module_scss_1.default[`preview-logo-${previewerSize}`]
        : ContentBlockCard_module_scss_1.default.logo;
    return (react_1.default.createElement("div", { className: `${ContentBlockCard_module_scss_1.default.logoWrapper} ${LOGO_POSITION_CLASS[logoPosition]}` },
        react_1.default.createElement("img", { src: logo1Src, alt: logoAccessibilityText, className: logoClassName, "data-testid": "content-block-card-logo-1" }),
        logo2Src && (react_1.default.createElement("img", { src: logo2Src, alt: logo2AccessibilityText || "", className: logoClassName, "data-testid": "content-block-card-logo-2" }))));
}
function ContentBlockCard({ associatedAdvertId, clickUrl, impressionUrl, title, description, desktopImage, accessibilityText, ctaLink, ctaText = "Shop now", logoImage, logoAccessibilityText, logoPosition, logo2Image, logo2AccessibilityText, previewerSize, }) {
    const imageSize = previewerSize
        ? PREVIEWER_IMAGE_SIZE[previewerSize]
        : "1274";
    const imageSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: imageSize,
        sm: "c",
    });
    const imageContainerClassName = previewerSize
        ? ContentBlockCard_module_scss_1.default[`preview-imageContainer-${previewerSize}`]
        : ContentBlockCard_module_scss_1.default.imageContainer;
    const contentClassName = previewerSize
        ? ContentBlockCard_module_scss_1.default[`preview-content-${previewerSize}`]
        : ContentBlockCard_module_scss_1.default.content;
    const titleClassName = previewerSize
        ? ContentBlockCard_module_scss_1.default[`preview-title-${previewerSize}`]
        : ContentBlockCard_module_scss_1.default.title;
    const descriptionClassName = previewerSize
        ? ContentBlockCard_module_scss_1.default[`preview-description-${previewerSize}`]
        : ContentBlockCard_module_scss_1.default.description;
    const ctaContainerClassName = previewerSize
        ? ContentBlockCard_module_scss_1.default[`preview-ctaContainer-${previewerSize}`]
        : ContentBlockCard_module_scss_1.default.ctaContainer;
    return (react_1.default.createElement("a", { href: ctaLink, className: ContentBlockCard_module_scss_1.default.card, "data-testid": "content-block-card", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        } },
        react_1.default.createElement("div", { className: imageContainerClassName },
            previewerSize ? (react_1.default.createElement("img", { src: imageSrc, alt: accessibilityText, "data-testid": "content-block-card-image" })) : (react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { media: "(min-width: 600px)", srcSet: imageSrc }),
                react_1.default.createElement("img", { src: imageSrc, alt: accessibilityText, className: ContentBlockCard_module_scss_1.default.image, "data-testid": "content-block-card-image" }))),
            react_1.default.createElement(LogoOverlay, { logoImage: logoImage, logoAccessibilityText: logoAccessibilityText, logoPosition: logoPosition, logo2Image: logo2Image, logo2AccessibilityText: logo2AccessibilityText, previewerSize: previewerSize })),
        react_1.default.createElement("div", { className: contentClassName },
            react_1.default.createElement("h3", { className: titleClassName, "data-testid": "content-block-card-title" }, title),
            react_1.default.createElement("p", { className: descriptionClassName, "data-testid": "content-block-card-description" }, description),
            react_1.default.createElement("div", { className: ctaContainerClassName, "data-testid": "content-block-card-cta" },
                react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", labelText: ctaText })))));
}
